const InteractiveMap = function($selector) {
	const module = {
		opts: {
			$module: $selector,
			// Style from snazzymaps.com -> based off style "Subtle Grayscale" by Paulo Avila
			styles: [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"administrative.neighborhood","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry.fill","stylers":[{"color":"#e6e3de"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#f1edea"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b8c4c7"}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}],
			selectors: {}
		},
		map: {},
		bindEvents: function() {},
		init: function() {
			this.map = this.initMap();
			this.initMarkers();
			this.centerMap();
		},
		initMap: function() {
			const { $module, styles } = this.opts;
			const map = new google.maps.Map( $module[0], {
				zoom : $module.data('zoom') || 4,
				mapTypeId : 'roadmap', // google.maps.MapTypeId.ROADMAP,
				center: { lat: -25.344, lng: 131.031 },
				disableDefaultUI: true,
				styles
			});
			return map;
		},
		initMarkers: function() {
			this.map.markers = [];
			this.opts.$module.data('markers').forEach(marker => this.addMarker(marker));
		},
		addMarker: function(data) {
			const marker = new google.maps.Marker({
				position: {
					lat: parseFloat( data['lat'] ),
					lng: parseFloat( data['lng'] )
				},
				icon: '/wp-content/themes/baker-home-exteriors/dist/images/icons/pin.svg',
				map: this.map
			});

			// Append to reference for later use.
			this.map.markers.push( marker );

			// If marker contains HTML, add it to an infoWindow.
			if( data.name.length ){

				// Create info window.
				const infowindow = new google.maps.InfoWindow({
					content: data.name
				});

				// Show info window when marker is clicked.
				google.maps.event.addListener(marker, 'click', function() {
					infowindow.open( this.map, marker );
				});
			}
		},
		centerMap: function() {
			const bounds = new google.maps.LatLngBounds();
			this.map.markers.forEach(function( marker ){
				bounds.extend({
					lat: marker.position.lat(),
					lng: marker.position.lng()
				});
			});

			// Case: Single marker.
			if( this.map.markers.length == 1 ){
				this.map.setCenter( bounds.getCenter() );

			// Case: Multiple markers.
			} else{
				this.map.fitBounds( bounds );
			}
		}
	}

	if ($selector.length && typeof google !== 'undefined') {
		module.init();
	}

	return module;
}


/**
 * Register after jQuery doc ready
 */
$(() => {
	new InteractiveMap($('.map-element'));
});
